/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { PropertyMatrixBaseServiceV2 } from '../property-matrix-base-service-v-2';
import { PropertyMatrixConfigurationV2 } from '../property-matrix-configuration-v-2';
import { PropertyMatrixStrictHttpResponseV2 } from '../property-matrix-strict-http-response-v-2';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { AdvertGeneratorDto } from '../models/advert-generator-dto';
import { AgentListingDto } from '../models/agent-listing-dto';
import { LatLongBoundsDto } from '../models/lat-long-bounds-dto';
import { MultiplePropertyListingDto } from '../models/multiple-property-listing-dto';
import { PropertyDetailDto } from '../models/property-detail-dto';
import { PropertyFilterDto } from '../models/property-filter-dto';
import { PropertyListingDto } from '../models/property-listing-dto';
import { TaskListDto } from '../models/task-list-dto';

@Injectable({
  providedIn: 'root',
})
export class PropertyListingService extends PropertyMatrixBaseServiceV2 {
  constructor(
    config: PropertyMatrixConfigurationV2,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiV1PropertyListingGetPropertyListingByIdGet
   */
  static readonly ApiV1PropertyListingGetPropertyListingByIdGetPath = '/api/v1/PropertyListing/GetPropertyListingById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetPropertyListingByIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetPropertyListingByIdGet$Response(params?: {
    listingId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<PropertyListingDto>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetPropertyListingByIdGetPath, 'get');
    if (params) {
      rb.query('listingId', params.listingId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<PropertyListingDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetPropertyListingByIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetPropertyListingByIdGet(params?: {
    listingId?: string;
    context?: HttpContext
  }
): Observable<PropertyListingDto> {

    return this.apiV1PropertyListingGetPropertyListingByIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<PropertyListingDto>) => r.body as PropertyListingDto)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetAllPropertyListingForCurrentUserGet
   */
  static readonly ApiV1PropertyListingGetAllPropertyListingForCurrentUserGetPath = '/api/v1/PropertyListing/GetAllPropertyListingForCurrentUser';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetAllPropertyListingForCurrentUserGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllPropertyListingForCurrentUserGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetAllPropertyListingForCurrentUserGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetAllPropertyListingForCurrentUserGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllPropertyListingForCurrentUserGet(params?: {
    context?: HttpContext
  }
): Observable<Array<PropertyListingDto>> {

    return this.apiV1PropertyListingGetAllPropertyListingForCurrentUserGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>) => r.body as Array<PropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingDeletePropertyListingDelete
   */
  static readonly ApiV1PropertyListingDeletePropertyListingDeletePath = '/api/v1/PropertyListing/DeletePropertyListing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingDeletePropertyListingDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingDeletePropertyListingDelete$Response(params?: {
    listingId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<void>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingDeletePropertyListingDeletePath, 'delete');
    if (params) {
      rb.query('listingId', params.listingId, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponseV2<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingDeletePropertyListingDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingDeletePropertyListingDelete(params?: {
    listingId?: string;
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1PropertyListingDeletePropertyListingDelete$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetAllPropertyListingsGet
   */
  static readonly ApiV1PropertyListingGetAllPropertyListingsGetPath = '/api/v1/PropertyListing/GetAllPropertyListings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetAllPropertyListingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllPropertyListingsGet$Response(params?: {
    isDeleted?: boolean;
    allCompanyListings?: boolean;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetAllPropertyListingsGetPath, 'get');
    if (params) {
      rb.query('isDeleted', params.isDeleted, {});
      rb.query('allCompanyListings', params.allCompanyListings, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetAllPropertyListingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllPropertyListingsGet(params?: {
    isDeleted?: boolean;
    allCompanyListings?: boolean;
    context?: HttpContext
  }
): Observable<Array<PropertyListingDto>> {

    return this.apiV1PropertyListingGetAllPropertyListingsGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>) => r.body as Array<PropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingSavePropertyListingDataPost
   */
  static readonly ApiV1PropertyListingSavePropertyListingDataPostPath = '/api/v1/PropertyListing/SavePropertyListingData';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingSavePropertyListingDataPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingSavePropertyListingDataPost$Response(params?: {
    custom?: boolean;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<void>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingSavePropertyListingDataPostPath, 'post');
    if (params) {
      rb.query('custom', params.custom, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponseV2<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingSavePropertyListingDataPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingSavePropertyListingDataPost(params?: {
    custom?: boolean;
    context?: HttpContext
  }
): Observable<void> {

    return this.apiV1PropertyListingSavePropertyListingDataPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetAllMultiplePropertyListingsGet
   */
  static readonly ApiV1PropertyListingGetAllMultiplePropertyListingsGetPath = '/api/v1/PropertyListing/GetAllMultiplePropertyListings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetAllMultiplePropertyListingsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllMultiplePropertyListingsGet$Response(params?: {
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<MultiplePropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetAllMultiplePropertyListingsGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<MultiplePropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetAllMultiplePropertyListingsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllMultiplePropertyListingsGet(params?: {
    context?: HttpContext
  }
): Observable<Array<MultiplePropertyListingDto>> {

    return this.apiV1PropertyListingGetAllMultiplePropertyListingsGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<MultiplePropertyListingDto>>) => r.body as Array<MultiplePropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingAddOrUpdateMultiplePropertyListingPost
   */
  static readonly ApiV1PropertyListingAddOrUpdateMultiplePropertyListingPostPath = '/api/v1/PropertyListing/AddOrUpdateMultiplePropertyListing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingAddOrUpdateMultiplePropertyListingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdateMultiplePropertyListingPost$Response(params?: {
    context?: HttpContext
    body?: MultiplePropertyListingDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<void>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingAddOrUpdateMultiplePropertyListingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponseV2<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingAddOrUpdateMultiplePropertyListingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdateMultiplePropertyListingPost(params?: {
    context?: HttpContext
    body?: MultiplePropertyListingDto
  }
): Observable<void> {

    return this.apiV1PropertyListingAddOrUpdateMultiplePropertyListingPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPost
   */
  static readonly ApiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPostPath = '/api/v1/PropertyListing/AddOrUpdateNetworkPlannerToPropertyListing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPost$Response(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<void>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponseV2<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPost(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<void> {

    return this.apiV1PropertyListingAddOrUpdateNetworkPlannerToPropertyListingPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPost
   */
  static readonly ApiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPostPath = '/api/v1/PropertyListing/UpdateNetworkConveyancerToPropertyListing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPost$Response(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<void>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponseV2<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPost(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<void> {

    return this.apiV1PropertyListingUpdateNetworkConveyancerToPropertyListingPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingEditOrUpdatePropertyDetailPost
   */
  static readonly ApiV1PropertyListingEditOrUpdatePropertyDetailPostPath = '/api/v1/PropertyListing/EditOrUpdatePropertyDetail';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingEditOrUpdatePropertyDetailPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingEditOrUpdatePropertyDetailPost$Response(params?: {
    propertyListingId?: string;
    context?: HttpContext
    body?: PropertyDetailDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<void>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingEditOrUpdatePropertyDetailPostPath, 'post');
    if (params) {
      rb.query('propertyListingId', params.propertyListingId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponseV2<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingEditOrUpdatePropertyDetailPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingEditOrUpdatePropertyDetailPost(params?: {
    propertyListingId?: string;
    context?: HttpContext
    body?: PropertyDetailDto
  }
): Observable<void> {

    return this.apiV1PropertyListingEditOrUpdatePropertyDetailPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPost
   */
  static readonly ApiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPostPath = '/api/v1/PropertyListing/AddOrUpdateAdvertCreatorToPropertyListing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPost$Response(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<void>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as PropertyMatrixStrictHttpResponseV2<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPost(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<void> {

    return this.apiV1PropertyListingAddOrUpdateAdvertCreatorToPropertyListingPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetTaskListsGet
   */
  static readonly ApiV1PropertyListingGetTaskListsGetPath = '/api/v1/PropertyListing/GetTaskLists';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetTaskListsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetTaskListsGet$Response(params?: {
    propertyListingId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetTaskListsGetPath, 'get');
    if (params) {
      rb.query('propertyListingId', params.propertyListingId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetTaskListsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetTaskListsGet(params?: {
    propertyListingId?: string;
    context?: HttpContext
  }
): Observable<Array<TaskListDto>> {

    return this.apiV1PropertyListingGetTaskListsGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>) => r.body as Array<TaskListDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingUpdateTaskListPost
   */
  static readonly ApiV1PropertyListingUpdateTaskListPostPath = '/api/v1/PropertyListing/UpdateTaskList';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingUpdateTaskListPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingUpdateTaskListPost$Response(params?: {
    context?: HttpContext
    body?: TaskListDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingUpdateTaskListPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as PropertyMatrixStrictHttpResponseV2<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingUpdateTaskListPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingUpdateTaskListPost(params?: {
    context?: HttpContext
    body?: TaskListDto
  }
): Observable<boolean> {

    return this.apiV1PropertyListingUpdateTaskListPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingCreateAllTaskForPropertyListingGet
   */
  static readonly ApiV1PropertyListingCreateAllTaskForPropertyListingGetPath = '/api/v1/PropertyListing/CreateAllTaskForPropertyListing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingCreateAllTaskForPropertyListingGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingCreateAllTaskForPropertyListingGet$Response(params?: {
    propertyListingId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingCreateAllTaskForPropertyListingGetPath, 'get');
    if (params) {
      rb.query('propertyListingId', params.propertyListingId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingCreateAllTaskForPropertyListingGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingCreateAllTaskForPropertyListingGet(params?: {
    propertyListingId?: string;
    context?: HttpContext
  }
): Observable<Array<TaskListDto>> {

    return this.apiV1PropertyListingCreateAllTaskForPropertyListingGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>) => r.body as Array<TaskListDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingUpdatePropertyListingTaskPost
   */
  static readonly ApiV1PropertyListingUpdatePropertyListingTaskPostPath = '/api/v1/PropertyListing/UpdatePropertyListingTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingUpdatePropertyListingTaskPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingUpdatePropertyListingTaskPost$Response(params?: {
    currentTaskNumber?: number;
    context?: HttpContext
    body?: Array<TaskListDto>
  }
): Observable<PropertyMatrixStrictHttpResponseV2<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingUpdatePropertyListingTaskPostPath, 'post');
    if (params) {
      rb.query('currentTaskNumber', params.currentTaskNumber, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as PropertyMatrixStrictHttpResponseV2<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingUpdatePropertyListingTaskPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingUpdatePropertyListingTaskPost(params?: {
    currentTaskNumber?: number;
    context?: HttpContext
    body?: Array<TaskListDto>
  }
): Observable<boolean> {

    return this.apiV1PropertyListingUpdatePropertyListingTaskPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingAddOrUpdatePlannersToPropertyListingPost
   */
  static readonly ApiV1PropertyListingAddOrUpdatePlannersToPropertyListingPostPath = '/api/v1/PropertyListing/AddOrUpdatePlannersToPropertyListing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingAddOrUpdatePlannersToPropertyListingPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdatePlannersToPropertyListingPost$Response(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<boolean>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingAddOrUpdatePlannersToPropertyListingPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as PropertyMatrixStrictHttpResponseV2<boolean>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingAddOrUpdatePlannersToPropertyListingPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingAddOrUpdatePlannersToPropertyListingPost(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<boolean> {

    return this.apiV1PropertyListingAddOrUpdatePlannersToPropertyListingPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<boolean>) => r.body as boolean)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingSetListingArchivedStatePost
   */
  static readonly ApiV1PropertyListingSetListingArchivedStatePostPath = '/api/v1/PropertyListing/SetListingArchivedState';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingSetListingArchivedStatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingSetListingArchivedStatePost$Response(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<PropertyListingDto>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingSetListingArchivedStatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<PropertyListingDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingSetListingArchivedStatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingSetListingArchivedStatePost(params?: {
    context?: HttpContext
    body?: PropertyListingDto
  }
): Observable<PropertyListingDto> {

    return this.apiV1PropertyListingSetListingArchivedStatePost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<PropertyListingDto>) => r.body as PropertyListingDto)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGet
   */
  static readonly ApiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGetPath = '/api/v1/PropertyListing/GetAgentsWithPropertyListingForPrincipleUserId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGet$Response(params?: {
    principleId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<AgentListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGetPath, 'get');
    if (params) {
      rb.query('principleId', params.principleId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<AgentListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGet(params?: {
    principleId?: string;
    context?: HttpContext
  }
): Observable<Array<AgentListingDto>> {

    return this.apiV1PropertyListingGetAgentsWithPropertyListingForPrincipleUserIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<AgentListingDto>>) => r.body as Array<AgentListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGet
   */
  static readonly ApiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGetPath = '/api/v1/PropertyListing/GetOnlyAgentPropertyListingForPrincipleUserId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGet$Response(params?: {
    principleId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGetPath, 'get');
    if (params) {
      rb.query('principleId', params.principleId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGet(params?: {
    principleId?: string;
    context?: HttpContext
  }
): Observable<Array<PropertyListingDto>> {

    return this.apiV1PropertyListingGetOnlyAgentPropertyListingForPrincipleUserIdGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>) => r.body as Array<PropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetPropertiesByBoundsPost
   */
  static readonly ApiV1PropertyListingGetPropertiesByBoundsPostPath = '/api/v1/PropertyListing/GetPropertiesByBounds';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetPropertiesByBoundsPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingGetPropertiesByBoundsPost$Response(params?: {
    context?: HttpContext
    body?: LatLongBoundsDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetPropertiesByBoundsPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetPropertiesByBoundsPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingGetPropertiesByBoundsPost(params?: {
    context?: HttpContext
    body?: LatLongBoundsDto
  }
): Observable<Array<PropertyListingDto>> {

    return this.apiV1PropertyListingGetPropertiesByBoundsPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>) => r.body as Array<PropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetPropertiesByFilterPost
   */
  static readonly ApiV1PropertyListingGetPropertiesByFilterPostPath = '/api/v1/PropertyListing/GetPropertiesByFilter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetPropertiesByFilterPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingGetPropertiesByFilterPost$Response(params?: {
    context?: HttpContext
    body?: PropertyFilterDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetPropertiesByFilterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetPropertiesByFilterPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingGetPropertiesByFilterPost(params?: {
    context?: HttpContext
    body?: PropertyFilterDto
  }
): Observable<Array<PropertyListingDto>> {

    return this.apiV1PropertyListingGetPropertiesByFilterPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>) => r.body as Array<PropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetPropertyAdvertsByFilterPost
   */
  static readonly ApiV1PropertyListingGetPropertyAdvertsByFilterPostPath = '/api/v1/PropertyListing/GetPropertyAdvertsByFilter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetPropertyAdvertsByFilterPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingGetPropertyAdvertsByFilterPost$Response(params?: {
    context?: HttpContext
    body?: PropertyFilterDto
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<AdvertGeneratorDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetPropertyAdvertsByFilterPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<AdvertGeneratorDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetPropertyAdvertsByFilterPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiV1PropertyListingGetPropertyAdvertsByFilterPost(params?: {
    context?: HttpContext
    body?: PropertyFilterDto
  }
): Observable<Array<AdvertGeneratorDto>> {

    return this.apiV1PropertyListingGetPropertyAdvertsByFilterPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<AdvertGeneratorDto>>) => r.body as Array<AdvertGeneratorDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetPropertiesByPropertyIdPost
   */
  static readonly ApiV1PropertyListingGetPropertiesByPropertyIdPostPath = '/api/v1/PropertyListing/GetPropertiesByPropertyId';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetPropertiesByPropertyIdPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetPropertiesByPropertyIdPost$Response(params?: {
    propertyListingId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetPropertiesByPropertyIdPostPath, 'post');
    if (params) {
      rb.query('propertyListingId', params.propertyListingId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetPropertiesByPropertyIdPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetPropertiesByPropertyIdPost(params?: {
    propertyListingId?: string;
    context?: HttpContext
  }
): Observable<Array<PropertyListingDto>> {

    return this.apiV1PropertyListingGetPropertiesByPropertyIdPost$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>) => r.body as Array<PropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGet
   */
  static readonly ApiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGetPath = '/api/v1/PropertyListing/GetAllPropertyListingForUserAndMyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGet$Response(params?: {
    userId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGetPath, 'get');
    if (params) {
      rb.query('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGet(params?: {
    userId?: string;
    context?: HttpContext
  }
): Observable<Array<PropertyListingDto>> {

    return this.apiV1PropertyListingGetAllPropertyListingForUserAndMyTaskGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<PropertyListingDto>>) => r.body as Array<PropertyListingDto>)
    );
  }

  /**
   * Path part for operation apiV1PropertyListingGetAllForUserAndMyTaskGet
   */
  static readonly ApiV1PropertyListingGetAllForUserAndMyTaskGetPath = '/api/v1/PropertyListing/GetAllForUserAndMyTask';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV1PropertyListingGetAllForUserAndMyTaskGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllForUserAndMyTaskGet$Response(params?: {
    UserId?: string;
    context?: HttpContext
  }
): Observable<PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>> {

    const rb = new RequestBuilder(this.rootUrl, PropertyListingService.ApiV1PropertyListingGetAllForUserAndMyTaskGetPath, 'get');
    if (params) {
      rb.query('UserId', params.UserId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `apiV1PropertyListingGetAllForUserAndMyTaskGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV1PropertyListingGetAllForUserAndMyTaskGet(params?: {
    UserId?: string;
    context?: HttpContext
  }
): Observable<Array<TaskListDto>> {

    return this.apiV1PropertyListingGetAllForUserAndMyTaskGet$Response(params).pipe(
      map((r: PropertyMatrixStrictHttpResponseV2<Array<TaskListDto>>) => r.body as Array<TaskListDto>)
    );
  }

}
